import * as Sentry from '@sentry/browser';
import Vue from 'vue';

const isProduction = process.env.NODE_ENV === 'production';

Sentry.init({
  dsn: 'https://a7b72659edbe415e8700337c1dd5394f@sentry.io/1399442',
  integrations: isProduction
    ? [new Sentry.Integrations.Vue({ Vue, attachProps: true })]
    : [],
  beforeSend(event) {
    return isProduction ? event : null;
  },
});



// WEBPACK FOOTER //
// ./src/plugins/sentry.js